module.exports = __webpack_public_path__ + "static/media/img_10.ee05f838.png";